"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _user = require("@/api/system/user");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ResetPassword',
  data: function data() {
    return {
      form: {
        userName: '',
        oldPwd: '',
        newPwd: '',
        verifyNewPwd: ''
      },
      passwordStrengthColor: '',
      passwordStrengthText: '',
      passwordStrengthTextEn: '',
      rules: {
        userName: [{
          required: true,
          message: this.$t("login.userHolder"),
          tigger: 'blur'
        }],
        oldPwd: [{
          required: true,
          message: this.$t("login.oldPwd"),
          tigger: 'blur'
        }],
        newPwd: [{
          required: true,
          message: this.$t("login.newPwd"),
          tigger: 'blur'
        }],
        verifyNewPwd: [{
          required: true,
          message: this.$t("login.verifyNewPwd"),
          tigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['userInfo', 'language'])), {}, {
    isShowPassword: {
      get: function get() {
        return this.$store.state.desktopConfig.isShowPassword;
      },
      set: function set(val) {
        return this.$store.dispatch('desktopConfig/showResetPassword', val);
      }
    },
    isMustModify: {
      get: function get() {
        return !this.$store.state.desktopConfig.isMustModify;
      },
      set: function set(val) {
        return this.$store.dispatch('desktopConfig/mustResetPassword', val);
      }
    }
  }),
  created: function created() {
    this.form.userName = this.userInfo.loginName;
  },
  methods: {
    submit: function submit() {
      var _this = this;
      this.$refs.resetForm.validate(function (valid) {
        if (valid) {
          var data = (0, _utils.deepClone)(_this.form);
          if (data.newPwd !== data.verifyNewPwd) {
            return _this.$message({
              type: 'error',
              message: '两次输入的密码不一致'
            });
          }
          (0, _user.resetPassword)(data).then(function (res) {
            if (res.success) {
              _this.$message({
                type: 'success',
                message: '修改成功'
              });
              _this.isShowPassword = false;
            } else {
              _this.$message({
                type: 'error',
                message: res.message
              });
            }
          }, function (err) {
            _this.$message({
              type: 'error',
              message: err.errorMessages[0]
            });
          });
        }
      });
    },
    handleInput: function handleInput(val) {
      var valid = (0, _utils.passwordStrength)(val);
      this.passwordStrengthColor = valid.passwordStrengthColor;
      this.passwordStrengthText = valid.passwordStrengthText;
      this.passwordStrengthTextEn = valid.passwordStrengthTextEn;
    },
    opened: function opened() {
      this.form = {
        userName: this.userInfo.loginName,
        oldPwd: '',
        newPwd: '',
        verifyNewPwd: ''
      };
    },
    // dialog close
    handleBeforeClose: function handleBeforeClose() {
      this.isShowPassword = false;
      this.$refs.resetForm.resetFields();
    }
  }
};